import { provideEffects } from '@ngrx/effects'
import { provideStore } from '@ngrx/store'
import { provideStoreDevtools } from '@ngrx/store-devtools'
import { BudgetEffects } from './budget/budget.effects'
import { budgetReducer } from './budget/budget.reducer'
import { BudgetService } from './budget/budget.service'
import { BudgetState } from './budget/budget.state'
import { CalendarEventsEffects } from './calendar-events/calendar-events.effects'
import { calendarEventsReducer } from './calendar-events/calendar-events.reducer'
import { CalendarEventsService } from './calendar-events/calendar-events.service'
import { CalendarEventsState } from './calendar-events/calendar-events.state'
import { LumpSumEffects } from './lump-sum/lump-sum.effects'
import { lumpSumReducer } from './lump-sum/lump-sum.reducer'
import { LumpSumService } from './lump-sum/lump-sum.service'
import { LumpSumState } from './lump-sum/lump-sum.state'
import { ProjectEffects } from './project/project.effects'
import { projectReducer } from './project/project.reducer'
import { ProjectService } from './project/project.service'
import { ProjectState } from './project/project.state'
import { StageEffects } from './stage/stage.effects'
import { stageReducer } from './stage/stage.reducer'
import { StageService } from './stage/stage.service'
import { StageState } from './stage/stage.state'
import { WbsService } from './wbs/services/wbs.service'
import { WbsEffects } from './wbs/wbs.effects'
import { wbsReducer } from './wbs/wbs.reducer'
import { WbsState } from './wbs/wbs.state'

export interface AppState {
   stage: StageState
   project: ProjectState
   wbs: WbsState
   budget: BudgetState
   calendar_events: CalendarEventsState
   lumpSum: LumpSumState
}

export const storageProviders = [
   provideStore({
      stage: stageReducer,
      project: projectReducer,
      wbs: wbsReducer,
      budget: budgetReducer,
      calendar_events: calendarEventsReducer,
      lumpSum: lumpSumReducer
   }),
   provideEffects([StageEffects, ProjectEffects, WbsEffects, BudgetEffects, CalendarEventsEffects, LumpSumEffects]),
   provideStoreDevtools({ maxAge: 25 }),
   StageService,
   ProjectService,
   WbsService,
   BudgetService,
   CalendarEventsService,
   LumpSumService
]
